export default __webpack_public_path__ + "static/scam-alert-mobile-57460e5deaef51b7e37814cf38b59e29.webp";